import React from 'react';
import { utcToZonedTime } from 'date-fns-tz';
import { withTheme } from 'styled-components';
import { getMonthHeaderTemplate, monthsOfYear } from '../../../helpers/dates';
import useTranslate from '../../../hooks/useTranslate';
import CloseIcon from '../Icons/CloseAlt';
import CalendarSelect from './CalendarSelect';
import * as Styled from './styled';
import { format, isSameDay, isSameYear } from 'date-fns';

interface ICalendarHeader {
  year: any;
  month: any;
  onChangeDate: any;
  daysTimes: any;
}

const CalendarHeader = ({ year, month, onChangeDate, daysTimes }: ICalendarHeader) => {
  const { t } = useTranslate();
  const headerTemplate = getMonthHeaderTemplate();

  const monthSet = new Set();
  const months = monthsOfYear();

  daysTimes.forEach((_, key) => {
    monthSet.add(format(new Date(key), 'yyyy-MM-01'));
  });

  const dates = Array.from(monthSet).map((date: string) => {
    const currentDate = utcToZonedTime(new Date(date).toISOString(), 'Europe/Moscow');

    const monthName = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    const renderYear = isSameYear(currentDate, new Date()) ? '' : ` ${year}`;
    return {
      label: `${monthName}${renderYear}`,
      value: date,
    };
  });

  const selectedMonthYear = dates.find(({ value }) =>
    isSameDay(new Date(value), new Date(`${year}-${month < 10 ? `0${month}` : month}-01`)),
  );

  return (
    <Styled.Header>
      <Styled.Title aria-live="assertive">{t('selectDateCalendar')}</Styled.Title>
      <Styled.CloseButton onClick={window.Widget.calendarController.hide}>
        <CloseIcon />
      </Styled.CloseButton>
      <Styled.Row>
        <CalendarSelect items={dates} onSelect={onChangeDate} selected={selectedMonthYear} />
      </Styled.Row>
      <Styled.Row>
        {headerTemplate.map((dayName, index) => (
          <Styled.HeaderCell key={dayName} aria-label={dayName} isWeekend={[5, 6].includes(index)}>
            {dayName}
          </Styled.HeaderCell>
        ))}
      </Styled.Row>
    </Styled.Header>
  );
};

// @ts-ignore
export default withTheme(CalendarHeader) as (props: ICalendarHeader) => JSX.Element;